<style lang="less">
.el-menu {
    border-right: 0px !important;
}
.iconfont {
    margin-right: 10px;
}
.el-submenu .el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
    color: #606266;
}
.el-menu-item-group__title {
    padding: 0 !important;
    line-height: 0 !important;
    height: 0 !important;
}
.el-submenu__title {
    color: #303133 !important;
    // font-size: 15px !important;
}
.el-menu-item.is-active {
    color: #409eff;
}
.el-submenu__icon-arrow {
    right: 20px !important;
}
.child {
    display: flex;
    align-items: center;
}
</style>

<template>
    <div class="page-menu">
        <el-menu :default-openeds="defaultOpeneds" :default-active="defaultActive" active-text-color="#409eff"
            class="el-menu-vertical-demo" v-if="loginState.admin" :unique-opened="true">
            <el-submenu :index="index+''" :key="index" v-for="(menu,index) in data">
                <template slot="title">
                    <i :class="menu.icon"></i>
                    <span>{{menu.text}}</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item :key="index2" :index="index+'-'+index2" v-for="(child,index2) in menu.submenus"
                        class="child" @click="changeRouter(child.path)">
                        {{child.text}}<i v-if="child.isCollection" class="el-icon-star-on"></i>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
    </div>
</template>

<script>
import { loginState } from "../util/login.js";
import { HttpClient } from "../util/http.js";

export default {
    created() {
        this.fetchData();
    },
    watch: {
        $route(to, from) {
            if (from.path == "/html-login") {
                this.fetchData();
            }
            if (to.path == "/html-login") {
                this.data = [];
                this.defaultActive = "";
                this.defaultOpeneds = [];
            }
            this.calcActiveIndex();
        },
    },
    computed: {},
    data() {
        return {
            loginState,
            data: [],
            defaultActive: "",
            defaultOpeneds: [],
        };
    },
    methods: {
        async fetchData() {
            this.data = loginState.getUserMenus();
        },
        calcActiveIndex() {
            let hitI = -1;
            let hitJ = -1;
            for (let i = 0; i < this.data.length; i++) {
                const parent = this.data[i];
                for (let j = 0; j < parent.submenus.length; j++) {
                    const child = parent.submenus[j];
                    if (
                        this.$route &&
                        this.$route.path &&
                        child.path == this.$route.path
                    ) {
                        hitI = i;
                        hitJ = j;
                    }
                }
            }
            if (hitI != -1 || hitJ != -1) {
                this.defaultActive = hitI + "-" + hitJ;
                this.defaultOpeneds = [hitI + ""];
            } else {
                this.defaultActive = "";
                this.defaultOpeneds = [];
            }
        },
        changeRouter(url) {
            this.$router.push(url);
        },
        iconfontAdd(className) {
            return `iconfont ${className}`;
        },
    },
};
</script>
